import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { JournalVersionsPage } from "./ui";

export const JournalsVersionsRoute = (): RouteObject => {
  return {
    path: `${routes.journals.versions()}`,
    element: createElement(JournalVersionsPage),
  };
};
